import { Box } from '@mui/material';
import { DropDown, ChipInput, ChipInputTagErrors } from '@qrios/frontend-library';

import {
  FILTERS,
  OPERATORS,
  USSD_SESSION_CLOSE_REASONS_QUERY,
  USSD_SESSION_TYPES
} from '../../../../../../common/filters';
import DateRangePicker from '../../../../../../common/fields/date-range-picker';
import { FiltersFormValues } from '../../../../../../common/reports/interfaces';

import locales from '../locales';
import { UssdReportCreateForm } from '../interfaces';
import {
  convertReadableToUssdSessionCloseReasonQuery,
  convertUssdSessionCloseReasonQueryToReadableFormat
} from '../../../../../../common/table/utils/operationTypeFormatters';

interface Props extends FiltersFormValues<UssdReportCreateForm> {}

const FiltersForm = ({ errors, touched, values, handleChange, handleBlur }: Props) => {
  const handleUssdSessionCloseReasonChange = (field: string, value: string[]) => {
    const convertedValue = value.map(queryTypeString => convertReadableToUssdSessionCloseReasonQuery(queryTypeString));
    handleChange(field, convertedValue);
  };

  return (
    <Box data-testid="ussd-reports-filters-form" mt={2} mb={6}>
      <DateRangePicker
        from={{ name: FILTERS.FROM, value: values.from, error: errors.from, touched: touched.from }}
        to={{ name: FILTERS.TO, value: values.to, error: errors.to, touched: touched.to }}
        handleFromChange={value => handleChange(FILTERS.FROM, value)}
        handleToChange={value => handleChange(FILTERS.TO, value)}
        handleBlur={handleBlur}
      />
      <DropDown
        label={locales.filtersForm.operators.label}
        value={values.operators}
        options={OPERATORS}
        name="operators"
        handleChange={handleChange}
        handleBlur={handleBlur}
        multiple={true}
        placeholder={locales.filtersForm.operators.placeholder}
      />
      <ChipInput
        error={errors.shortcodes?.[(errors.shortcodes ?? []).length - 1]}
        label={locales.filtersForm.shortcodes.label}
        value={values.shortcodes}
        name="shortcodes"
        handleChange={handleChange}
        handleBlur={handleBlur}
        placeholder={locales.filtersForm.shortcodes.placeholder}
        tagErrors={errors.shortcodes as ChipInputTagErrors}
      />
      <ChipInput
        error={errors.operationIds?.[(errors.operationIds ?? []).length - 1]}
        label={locales.filtersForm.operationIds.label}
        value={values.operationIds}
        name="operationIds"
        handleChange={handleChange}
        handleBlur={handleBlur}
        placeholder={locales.filtersForm.operationIds.placeholder}
        tagErrors={errors.operationIds as ChipInputTagErrors}
      />
      <ChipInput
        error={errors.msisdns?.[(errors.msisdns ?? []).length - 1]}
        label={locales.filtersForm.phoneNumbers.label}
        value={values.msisdns}
        name="msisdns"
        handleChange={handleChange}
        handleBlur={handleBlur}
        placeholder={locales.filtersForm.phoneNumbers.placeholder}
        tagErrors={errors.msisdns as ChipInputTagErrors}
      />
      <DropDown
        label={locales.filtersForm.sessionTypes.label}
        value={values.sessionTypes}
        options={USSD_SESSION_TYPES}
        name="sessionTypes"
        handleChange={handleChange}
        handleBlur={handleBlur}
        multiple={true}
        placeholder={locales.filtersForm.sessionTypes.placeholder}
      />
      <ChipInput
        error={errors.sessionTags?.[(errors.sessionTags ?? []).length - 1]}
        label={locales.filtersForm.sessionTags.label}
        value={values.sessionTags}
        name="sessionTags"
        handleChange={handleChange}
        handleBlur={handleBlur}
        placeholder={locales.filtersForm.sessionTags.placeholder}
        tagErrors={errors.sessionTags as ChipInputTagErrors}
        helperText={locales.filtersForm.sessionTags.helperText}
      />
      <DropDown
        label={locales.filtersForm.sessionCloseReasons.label}
        value={values.sessionCloseReasons.map(reason => convertUssdSessionCloseReasonQueryToReadableFormat(reason))}
        options={USSD_SESSION_CLOSE_REASONS_QUERY.map(reason =>
          convertUssdSessionCloseReasonQueryToReadableFormat(reason)
        )}
        name="sessionCloseReasons"
        handleChange={handleUssdSessionCloseReasonChange}
        handleBlur={handleBlur}
        multiple={true}
        placeholder={locales.filtersForm.sessionCloseReasons.placeholder}
      />
    </Box>
  );
};

export default FiltersForm;
